import React, { useMemo, useRef } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import { CSVLink } from "react-csv";
import { useReactToPrint } from "react-to-print";

// Sample Data
const data = [
  { name: "Yuvraj", role: "Full Stack Developer", location: "Pune", demo: "Demo1sdwdsdsdsd", test: "test1sdfffffffffffffff", sample: "Sample1awwdssssssssssssssssssssssssssss"},
  { name: "Chetan", role: "Backend Developer", location: "Mumbai", demo: "Demo2sdwdsdsdsd", test: "test2sdfffffffffffffff", sample: "Sample2awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
  { name: "Vivek", role: "UI Designer", location: "Delhi", demo: "Demo3sdwdsdsdsd", test: "testsdfffffffffffffff3sdfffffffffffffff", sample: "Sample3awwdssssssssssssssssssssssssssss"},
];

const columns = [
  { Header: "Name", accessor: "name" },
  { Header: "Role", accessor: "role" },
  { Header: "Location", accessor: "location" },
  { Header: "Demo", accessor: "demo" },
  { Header: "Test", accessor: "test" },
  { Header: "Sample", accessor: "sample" },
];

const CustomTable = () => {
  const memoColumns = useMemo(() => columns, []);
  const memoData = useMemo(() => data, []);

  const tableInstance = useTable(
    { columns: memoColumns, data: memoData },
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state: { pageIndex, globalFilter },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
  } = tableInstance;

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <div className="p-4 table-responsive">
      <div className="mb-3 flex gap-4 items-center">
        <input
          type="text"
          placeholder="Search..."
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="border px-2 py-1 rounded"
        />
        <CSVLink data={memoData} className="btn btn-success float-right">
          Download CSV
        </CSVLink>
        {/* <button onClick={handlePrint} className="btn btn-sm btn-outline-danger float-right mr-1">
          Print
        </button> */}
      </div>

      <div ref={printRef}>
        <table {...getTableProps()} className="min-w-full border border-gray-300 table" id="datatable-button">
          <thead className="bg-dark text-white">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} className="px-4 py-2 border text-white">
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} className="px-4 py-2 border">
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex justify-between items-center">
  {/* Page size dropdown */}
  <select
    value={tableInstance.state.pageSize}
    onChange={(e) => tableInstance.setPageSize(Number(e.target.value))}
    className="border px-2 py-1 rounded bg-green-600 text-white"
  >
    {[10, 20, 30, 40, 50].map((size) => (
      <option key={size} value={size}>
        {size}
      </option>
    ))}
  </select>

  {/* Pagination Buttons */}
  <div className="flex items-center space-x-1">
    <button
      onClick={() => previousPage()}
      disabled={!canPreviousPage}
      className="px-3 py-1 border rounded disabled:opacity-50"
    >
      Prev
    </button>

    {pageOptions.map((page, i) => (
      <button
        key={i}
        onClick={() => tableInstance.gotoPage(page)}
        className={`px-3 py-1 border rounded ${
          pageIndex === page ? "bg-green-600 text-white" : ""
        }`}
      >
        {page + 1}
      </button>
    ))}

    <button
      onClick={() => nextPage()}
      disabled={!canNextPage}
      className="px-3 py-1 border rounded disabled:opacity-50"
    >
      Next
    </button>
  </div>
</div>

    </div>
  );
};

export default CustomTable;
